import fila from './fila'
import parametrizacao from './parametrizacao'
import solicitacao from './solicitacao'
import status from './status'

export default [
    {
        path: 'regulacao',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...fila,
            ...parametrizacao,
            ...solicitacao,
            ...status,
        ]
    }
]